import { render, staticRenderFns } from "./listTrip.vue?vue&type=template&id=606fdbb2&scoped=true"
import script from "./listTrip.vue?vue&type=script&lang=js"
export * from "./listTrip.vue?vue&type=script&lang=js"
import style0 from "./listTrip.vue?vue&type=style&index=0&id=606fdbb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606fdbb2",
  null
  
)

export default component.exports